import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import { getBackofficeScheduledReportsQueryKey } from "modules/backoffice/lib/scheduledReports/getBackofficeScheduledReportsQuery"
import { DataResponse, UpsertBackofficeScheduledReportSchema } from "schema"
import { z } from "zod"

type Response = DataResponse<z.infer<typeof UpsertBackofficeScheduledReportSchema>>

type Props = {
  onSuccess?: () => void
}

export function useCreateBackofficeScheduledReportsMutation({ onSuccess }: Props = {}) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (data: z.input<typeof UpsertBackofficeScheduledReportSchema>) => {
      const response = await axios.post<Response>(`/backoffice/scheduledReports`, data)

      return response.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: getBackofficeScheduledReportsQueryKey() })

      onSuccess?.()
    },
  })
}
